module.exports = __webpack_public_path__ + "static/img/coinDepositColor.77c4306.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dailyFreeCash/coinDepositColor.gif
// module id = 4Sbq
// module chunks = 0